import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=647ec08b&scoped=true&"
import script from "./InstitutionList.vue?vue&type=script&lang=js&"
export * from "./InstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionList.vue?vue&type=style&index=0&id=647ec08b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ec08b",
  null
  
)

export default component.exports